var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenchmarkShadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_14896_197804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.78418 10.8652H21.7572",
    stroke: "#2C2C2C",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24316 10.9176L11.2946 7.86621",
    stroke: "#2C2C2C",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24316 10.9179L11.2946 14.4053",
    stroke: "#2C2C2C",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5V17",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 5V17",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7568 10.9176L18.7054 7.86621",
    stroke: "#2C2C2C",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7568 10.9179L18.7054 14.4053",
    stroke: "#2C2C2C",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3C5.55228 3 6 3.44772 6 4V16C6 16.5523 5.55228 17 5 17C4.44772 17 4 16.5523 4 16V4C4 3.44772 4.44772 3 5 3ZM11.7544 6.4063C12.0082 6.66014 12.0082 7.0717 11.7544 7.32554L9.86506 9.21486H20.1349L18.2456 7.32554C17.9918 7.0717 17.9918 6.66014 18.2456 6.4063C18.4995 6.15246 18.911 6.15246 19.1649 6.4063L22.0366 9.278C22.2555 9.38257 22.4068 9.60606 22.4068 9.86486C22.4068 9.87403 22.4066 9.88314 22.4062 9.89221C22.4064 9.89853 22.4066 9.90485 22.4066 9.91117C22.4083 10.0654 22.3554 10.2207 22.2458 10.3459L19.1944 13.8332C18.958 14.1034 18.5474 14.1308 18.2772 13.8944C18.007 13.658 17.9797 13.2473 18.2161 12.9772L20.3706 10.5149H9.62942L11.7839 12.9772C12.0203 13.2473 11.993 13.658 11.7228 13.8944C11.4526 14.1308 11.042 14.1034 10.8056 13.8332L7.75415 10.3459C7.64471 10.2208 7.59181 10.0656 7.59335 9.91156C7.59481 9.74715 7.65826 9.58318 7.7837 9.45774L10.8351 6.4063C11.089 6.15246 11.5005 6.15246 11.7544 6.4063ZM26 4C26 3.44772 25.5523 3 25 3C24.4477 3 24 3.44772 24 4V16C24 16.5523 24.4477 17 25 17C25.5523 17 26 16.5523 26 16V4Z",
    fill: "#2C2C2C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_14896_197804",
    x: 0,
    y: 0,
    width: 30,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_14896_197804"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmarkShadow);
export default __webpack_public_path__ + "static/media/benchmark-shadow.2f11b4ca3097566cb0e3d2fc41bd36b0.svg";
export { ForwardRef as ReactComponent };